"use client";
import React from "react";

export default function Back_EndContent({ data }: any) {
  if (data === null) return null;
  return (
    <div
      className="container px-4 mx-auto lg:py-[56px] w-full lg:w-[70%]"
      dangerouslySetInnerHTML={{ __html: data }}
    />
  );
}
